module.exports = __webpack_public_path__ + "static/media/cake-expert.a30550cb.png";